import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import useQuery from "../utils/useQuery";
import { axiosPrivate, axiosQuick } from "../api/axios";
import "../assets/scss/components/dashboard.scss";
import Header from "../components/shared/header";
import moment from "moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddUser from "../components/adduser";
import { categoryList } from "../data/categories";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import loader from "../utils/Helper";
import { Tooltip, CircularProgress} from "@mui/material";
import _ from "lodash";

const DELETE_USER = "/deleteUser";
const REACTIVATE_USER = "/reactivateUser";
const GET_USERS = "/getAllCustomers";
const GET_USER = "/account";

const EndUserList = () => {
  const toast = useRef(null);
  const { setQueryData } = useQuery();
  const [query, setQuery] = useState(null);

  const [displayResponsive, setDisplayResponsive] = useState(false);
  const userData = JSON.parse(localStorage.getItem("user"));
  const [tableData, setTableData] = useState(false);
  const [departmentFilter, setDepartmentFilter] = useState(null);
  const statusList = [
    { status: "All", code: null },
    { status: "Active", code: true },
    { status: "In-Active", code: false },
  ];
  const [statusFilter, setStatusFilter] = useState(statusList[0]);
  const [account, setAccount] = useState(null);
  const [exportRunning, setexportRunning] = useState(false);

  const getData = async () => {
    loader.isLoading(true);
    const response = await axiosQuick.get(`${GET_USERS}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.jwtToken}`,
      },
    });
    setQuery(response.data);
    setTableData(response.data);
    let id;
    if (query) {
      query.map((singleItem, index) => {
        id = singleItem.id;
      });
      setQueryData({
        id: id,
      });
    } else {
    }
    loader.isLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);


  const createdOnBodyTemplate = (rowData) => {
    return   moment.utc(rowData.createdOn).local().format("MMMM DD, YYYY");
    //  moment(new Date(rowData.createdOn)).format("MMMM DD, YYYY");
  };

  const handleSearch = (e) => {
  
    if (e.target.value != "") {
      var res = query.filter(
        (a) =>
          (a.referenceName?.toLowerCase().includes(e.target.value.toLowerCase()) ||
           
            a.email?.toLowerCase().includes(e.target.value.toLowerCase())) &&
          (!departmentFilter || a.categoryId.includes(departmentFilter.id) )
      );
      setTableData(res);
    } else {
      var res = query.filter(
        (a) => !departmentFilter || a.categoryId.includes(departmentFilter.id)
      );
      setTableData(res);
    }
  };

  const rowClass = (data) => {
    if (new Date(data.dueDate) < new Date()) {
      return {
        dueDateGone: true,
      };
    }

    if (
      new Date(data.dueDate) > new Date() &&
      parseInt(
        (new Date(data.dueDate) - new Date()) / (1000 * 60 * 60 * 24),
        10
      ) < 3
    ) {
      return {
        dueDateNear: true,
      };
    }
  };


  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      setexportRunning(true);
      loader.isLoading(true)
      const CustomHeadersKeys = {
        username: "Username",
        referenceName: "Name",
        email: "Email",
        phone: "Phone Number",
      };
      const keysToRemove = [
        "id",
        "roleId",
        "categoryId",
        "whatsAppPhone",
        "streetAddress",
        "city",
        "state",
        "country",
        "companyName",
        "pan",
        "zipCode",
        "isActive",
        "queryCount",
        "createdOn",
        "isProfileComplete"
      ];
       const columnOrder = [
        "username",
        "referenceName",
        "email",
        "phone"
      ];

      const sortedTableData = [...tableData].sort((a, b) =>
      (a.username || "").localeCompare(b.username || "", undefined, {
        sensitivity: "base",
        numeric: true,
      })
    );

      const selectedTabledata = sortedTableData.map((obj) => {
      const filtered = _.omit(obj, keysToRemove);

      // Build object in exact order
      return columnOrder.reduce((acc, key) => {
        if (filtered[key] !== undefined) {
          acc[CustomHeadersKeys[key] || key] = filtered[key];
        }
        return acc;
      }, {});
    });

    const worksheet = xlsx.utils.json_to_sheet(selectedTabledata);

    const workbook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };

    const excelBuffer = xlsx.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

         saveAsExcelFile(excelBuffer, "Users");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
  
        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
      setexportRunning(false);
      loader.isLoading(false);
    }).catch((err) => {
      setexportRunning(false);
    });
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <Toast ref={toast} />
      <Header />

      {/* <Dialog
        header={account ? "Update Consultant Details" : " Add User"}
        visible={displayResponsive}
        onHide={() => {
          setDisplayResponsive(false);
          setAccount(null);
          
        }}
        
        style={{width:'75%',height:'80%'}}
      >
        <AddUser
          reloadData={getData}
          hidePopup={setDisplayResponsive}
          existinguser={account}
        />
      </Dialog> */}

      <div className="dashboard-area">
        {userData.isSuperAdmin && (
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-sm-12">
              <div>
                <div className="row">
                  <div className="col-sm-6">
                    <span className="p-input-icon-left">
                      <i className="pi pi-search" />
                      <InputText placeholder="Search" onChange={handleSearch}/>
                    </span>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className="btn-create-small submitbutton"
                      style={{ cursor: "pointer",marginTop:'0px' }}
                      onClick={!exportRunning ? exportExcel : null}
                      data-pr-tooltip="XLS"
                    >
                      {exportRunning ? (
                        <>
                          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                          <CircularProgress size={15} />
                        </>
                      ) : (
                        <>
                          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                          Export All
                        </>
                      )}
                    </div>
                    {/* <div
                      className="btn-create-small"
                      style={{ cursor: "pointer",marginTop:'0px' }}
                      onClick={() => setDisplayResponsive(true)}
                    >
                      <i
                        title=" Add Consultant"
                        className="fa-solid fa-plus px-2"
                      ></i>
                      Add Consultant
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-12">
            {query && (
              <div className="add-scroll">
                <DataTable
                  value={tableData}
                  paginator
                  rows={10}
                  responsiveLayout="scroll"
                  rowClassName={rowClass}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rowsPerPageOptions={[10, 20, 50]}
                  sortField="username" sortOrder={1}
                >
                  <Column field="username" header="Username" sortable></Column>
                  <Column field="referenceName" header="Name" sortable
                  ></Column>
                  <Column field="email" header="Email" sortable></Column>
                  <Column field="phone" header="Phone Number" sortable></Column>
                  <Column
                    field="createdOn"
                    header="Created On"
                    body={createdOnBodyTemplate}
                    sortable
                  ></Column>
                </DataTable>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default EndUserList;
